import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 题库管理 — 字段较多, 当前只列核心字段 (后续 user 补充复合题/匹配/多媒体定制 UI).
 *
 * TODO (user 后续):
 *   - 选项/匹配 JSON 字段需要专门可视化编辑器
 *   - 多语言 content/explanation 走 Tab
 *   - 复合题父子关系 (parent_question) 用树形选择器
 *   - 媒体资源 (audio/video/image) 用上传组件
 */
export const questionsConfig: CrudConfig = {
  resource: 'questions',
  title: '题库管理',
  rowKey: 'id',
  searchFields: ['question_type', 'answer_type', 'industry', 'level'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'uuid', label: 'UUID', type: 'text', copyable: true, width: 260, readonly: true, hideInTable: true, hideInSearch: true },
    {
      name: 'question_type',
      label: '题型',
      type: 'select',
      required: true,
      width: 100,
      options: [
        { label: '听力', value: 'L', color: 'blue' },
        { label: '阅读', value: 'R', color: 'cyan' },
        { label: '阅读2', value: 'R2', color: 'cyan' },
        { label: '阅读3', value: 'R3', color: 'cyan' },
        { label: '口语', value: 'I', color: 'gold' },
        { label: '口语2', value: 'I2', color: 'gold' },
        { label: '看图', value: 'V', color: 'purple' },
      ],
    },
    {
      name: 'answer_type',
      label: '答案类型',
      type: 'select',
      required: true,
      width: 110,
      options: [
        { label: '单选', value: 'S' },
        { label: '填空', value: 'W' },
        { label: '多选', value: 'C' },
        { label: '多选2', value: 'C2' },
        { label: '拖拽', value: 'D' },
        { label: '完形', value: 'CI' },
        { label: '判断', value: 'J' },
        { label: '匹配', value: 'M' },
      ],
    },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100 },
    { name: 'level', label: '等级', type: 'number', width: 80 },
    { name: 'display_content', label: '题干', type: 'readonly', ellipsis: true, hideInForm: true, readonly: true },
    { name: 'content', label: '题干内容', type: 'textarea', hideInTable: true, tooltip: '当前语言文本; 多语言版用专属 Form (TODO)' },
    { name: 'choices', label: '选项 (JSON)', type: 'json', hideInTable: true, tooltip: '形如 [{"id":"A","text":"..."}]' },
    { name: 'correct_answer', label: '正确答案 (JSON)', type: 'json', hideInTable: true },
    { name: 'score', label: '分值', type: 'number', width: 80, hideInSearch: true },
    { name: 'is_active', label: '启用', type: 'boolean', width: 90 },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true, hideInTable: true },
  ],
};
